import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PriceBookEntryParams } from 'models/PriceBookEntry';

const initialState: PriceBookEntryParams = {
  offset: 0,
  take: 25,
  sourceProductNumber: undefined,
  productNumber: undefined,
  condition: undefined,
  effectiveDate: undefined,
  effectiveDateFrom: undefined,
  effectiveDateTo: undefined,
  includeDeletedData: undefined
};

export const juliaPriceBookEntryParams = createSlice({
  name: 'juliaPriceBookEntryParams',
  initialState,
  reducers: {
    setPriceBookOffset: (state, { payload }: PayloadAction<PriceBookEntryParams['offset']>) => {
      state.offset = payload;
    },
    setPriceBookTake: (state, { payload }: PayloadAction<PriceBookEntryParams['take']>) => {
      state.take = payload;
      state.offset = 0;
    },
    setPriceBookProductNumber: (state, { payload }: PayloadAction<PriceBookEntryParams['productNumber']>) => {
      state.productNumber = payload;
      state.offset = 0;
    },
    setPriceBookSourceProductNumber: (state, { payload }: PayloadAction<PriceBookEntryParams['sourceProductNumber']>) => {
      state.sourceProductNumber = payload;
      state.productNumber = payload;
      state.offset = 0;
    },
    setPriceBookCondition: (state, { payload }: PayloadAction<PriceBookEntryParams['condition']>) => {
      state.condition = payload;
      state.offset = 0;
    },
    setPriceBookEffectiveDate: (state, { payload }: PayloadAction<PriceBookEntryParams['effectiveDate']>) => {
      state.effectiveDate = payload;
      state.offset = 0;
    },
    setPriceBookEffectiveDateRange: (state, { payload }: PayloadAction<{ from?: string; to?: string }>) => {
      state.effectiveDateFrom = payload.from;
      state.effectiveDateTo = payload.to;
      state.offset = 0;
    },
    setPriceBookIncludeDeletedData: (state, { payload }: PayloadAction<PriceBookEntryParams['includeDeletedData']>) => {
      state.includeDeletedData = payload;
      state.offset = 0;
    },
    resetPriceBookParams(state) {
      Object.assign(state, initialState);
    }
  }
});

export const {
  setPriceBookOffset,
  setPriceBookTake,
  setPriceBookProductNumber,
  setPriceBookSourceProductNumber,
  setPriceBookCondition,
  setPriceBookEffectiveDate,
  setPriceBookEffectiveDateRange,
  setPriceBookIncludeDeletedData,
  resetPriceBookParams
} = juliaPriceBookEntryParams.actions;
